import { onBeforeUnmount, onMounted, toValue } from 'vue';

/**
 * Invoke `handler` on any pointerdown outside `target`.
 *
 * Adaptable: `target` may be a plain element, a ref, or a getter
 * (MaybeRefOrGetter<HTMLElement|null>) — it is normalized with toValue()
 * at event time so late-mounting template refs and computed targets work.
 *
 * @param {import('vue').MaybeRefOrGetter<HTMLElement|null>} target
 * @param {(e: PointerEvent) => void} handler
 */
export default function useClickOutside(target, handler) {
  const onPointerDown = (e) => {
    const el = toValue(target);
    if (el && !el.contains(e.target)) handler(e);
  };

  onMounted(() => document.addEventListener('pointerdown', onPointerDown, true));
  onBeforeUnmount(() => document.removeEventListener('pointerdown', onPointerDown, true));
}
